import FormCreateOrEditTransactionFooter from './FormCreateOrEditTransactionFooter';
import FormCreateOrEditTransactionHeader from './FormCreateOrEditTransactionHeader';
import FormCreateOrEditTransactionBody from './formCreateOrEditTransactionBody';
import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import { TransactionTypeEnum } from '@/enums';
import { FormLabelErrorMessage } from '@/components/forms';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { ScrollArea } from '@/components/ui';
import type { TFormData } from '.';
import dayjs from '@/config/dayjs';
import type{ ITransactionFormProps } from '@/interfaces';

const VARIABLES = {
	formConfig: {
		...DEFAULT_FORM_CONFIG,
		defaultValues: {
			type: TransactionTypeEnum.EXPENSE,
			mode: 'MANUAL' as const,
			amountEur: '',
			category: '',
			occurredAt: dayjs().format('YYYY-MM-DD')
		}
	} as UseFormProps<TFormData>
};

const FormCreateOrEditTransaction = ({ transaction, onSuccess, onCancel, readonly: propsReadonly }: ITransactionFormProps) => {
	const formMethods = useForm<TFormData>({
		...VARIABLES.formConfig,
		values: {
			...VARIABLES.formConfig.defaultValues,
			...(transaction
				? {
						_id: transaction._id,
						amountEur: transaction.amountEur?.toString() || '0',
						occurredAt: transaction.occurredAt || dayjs(transaction.createdAt).format('YYYY-MM-DD'),
						category: transaction.category,
						mode: transaction.mode || 'MANUAL',
						type: transaction.type,
						title: transaction.title,
						description: transaction.description,
						data: transaction.data,
						readonly: propsReadonly
					}
				: {})
		} as TFormData
	});
	const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

	return (
		<FormProvider {...formMethods}>
			<FormCreateOrEditTransactionHeader />
			<ScrollArea className="flex-1 max-h-[60vh] md:max-h-[70vh]">
				<div className="px-1 md:px-1 pb-0">
					<FormCreateOrEditTransactionBody />
				</div>
			</ScrollArea>
			<FormLabelErrorMessage errorMessage={errorMessage} />
			<FormCreateOrEditTransactionFooter onSuccess={onSuccess} onCancel={onCancel} />
		</FormProvider>
	);
};

export default FormCreateOrEditTransaction;
